import(/* webpackMode: "eager" */ "/Users/gopal/BlindsCode/bc-tracking-wt/app/guides/measuring-arched-windows/page.tsx");
